import { forwardRef } from 'react';

import * as style from './style.module.css';

const InputText = forwardRef(
    ({ type = 'text', isError = false, disabled = false, onEnter = () => {}, onKeyDown = () => {}, ...props }, ref) => {
        return (
            <input
                {...props}
                ref={ref}
                className={`${style.inputText} ${isError ? style.inputError : ''} ${disabled ? style.disabled : ''}`}
                type={type}
                disabled={disabled}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        onEnter();
                    }
                    onKeyDown(event);
                }}
            />
        );
    },
);

InputText.displayName = 'InputText';

export default InputText;
